import React, { forwardRef, ForwardedRef, useCallback, useState } from "react";
import cx from "classnames";
import { useInputGroupState } from "@smartsuite/react-ui/lib/hooks/useInputGroupState/useInputGroupState";
import { Icon } from "@smartsuite/react-ui/lib/components/utils/Icon/Icon";
import { Text } from "@smartsuite/react-ui/lib/components/typography/Text/Text";
import { PlainTextField } from "@smartsuite/react-ui/lib/components/forms/PlainTextField/PlainTextField";
import { ColorMixer } from "@smartsuite/react-ui/lib/components/forms/ColorMixer";

interface CustomPickerColorSelectProps {
  className?: string;

  onCancel: () => void;
  onChange: (color: string) => void;
}

export const CustomPickerColorSelect = forwardRef(
  (
    { className, onCancel, onChange }: CustomPickerColorSelectProps,
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    const classes = cx(className, "custom-picker-color-select");
    const [currentColor, setCurrentColor] = useState("#000000");
    const { state, onBlur, onFocus } = useInputGroupState();

    const handleSave = useCallback(() => {
      onChange(currentColor);
    }, [onChange, currentColor]);

    return (
      <div ref={ref} className={classes}>
        <button
          type="button"
          className="custom-picker-color-select__header"
          onClick={onCancel}
        >
          <Icon
            className="custom-picker-color-select__icon"
            name="arrow-left-1"
            size="M"
            color="currentColor"
          />
          <Text weight="semibold" size="s">
            Add Custom Color
          </Text>
        </button>
        <div className="custom-picker-color-select__body">
          <PlainTextField
            label="HEX"
            value={currentColor}
            state={state}
            onFocus={onFocus}
            onBlur={onBlur}
            onChangeValue={setCurrentColor}
          />
          <div className="custom-picker-color-select__picker">
            <ColorMixer color={currentColor} onChange={setCurrentColor} />
          </div>
        </div>
        <div className="custom-picker-color-select__footer">
          <Text
            tag="button"
            weight="medium"
            size="xs"
            className="custom-picker-color-select__button"
            onClick={onCancel}
          >
            Cancel
          </Text>
          <Text
            tag="button"
            weight="medium"
            size="xs"
            className="custom-picker-color-select__button custom-picker-color-select__button--add"
            onClick={handleSave}
          >
            Add Color
          </Text>
        </div>
      </div>
    );
  },
);

CustomPickerColorSelect.displayName = "CustomPickerColorSelect";
